import { render, staticRenderFns } from "./ConfigUsuariosListagem.vue?vue&type=template&id=5b47675b&scoped=true&lang=pug&"
import script from "./ConfigUsuariosListagem.vue?vue&type=script&lang=js&"
export * from "./ConfigUsuariosListagem.vue?vue&type=script&lang=js&"
import style0 from "./ConfigUsuariosListagem.vue?vue&type=style&index=0&id=5b47675b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b47675b",
  null
  
)

export default component.exports